import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IMenuSetResponseBody } from './types';

export const getMenuSet = async (menuSetId: string): Promise<IMenuSetResponseBody> => {
  try {
    const res = await fetch(`${API_URL}/menus/menu-sets/${menuSetId}`);

    if (!res.ok) throw new Error(res.statusText);

    return await res.json();
  } catch (e) {
    throw e instanceof Error ? e : new Error(String(e));
  }
};
